import * as React from "react";
import * as ReactDOM from "react-dom";
import { OffsetText } from "src/Components/OffsetText";

import { RightAlignedText } from "src/Components/RightAlignedText";
import * as PoemUtils from "./PoemUtils";

enum Month {
    Jan = 0,
    Feb = 1,
    Mar = 2,
    Apr = 3,
    May = 4,
    Jun = 5,
    Jul = 6,
    Aug = 7,
    Sep = 8,
    Oct = 9,
    Nov = 10,
    Dec = 11
}

class ReactComment extends React.Component<{ text: string }, {}> {
    public componentDidMount() {
        const el: Element = ReactDOM.findDOMNode(this) as Element;
        ReactDOM.unmountComponentAtNode(el);
        el.outerHTML = this.createComment();
    }

    public render() {
        return <div />;
    }

    private createComment() {
        return `<!-- ${this.props.text} -->`;
    }
}

export const poems: Poem[] = [
    {
        date: new Date(2018, Month.Dec, 7),
        name: "plans for life",
        poem: PoemUtils.twoPhrasePoem(
            "not learn how to be emotionally available",
            "die"
        )
    },
    {
        date: new Date(2018, Month.Dec, 10),
        name: "soft",
        poem: (
            <div>
                people always say millenials are soft
                <br />
                <br />
                <br />
                <br />
                <br />i still want my mom to do everything for me
            </div>
        )
    },
    {
        date: new Date(2018, Month.Dec, 10),
        name: "always",
        poem: (
            <div>
                i want
                <br />
                to
                <br />
                <br />
                <br />
                <br />
                touch
                <br />
                <br />
                <br />
                my
                <br />
                <br />
                self
                <br />
                <br />
                <br />
                <br />
                <br />
                all
                <br />
                <br />
                <br />
                <br />
                <br />
                the
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                time
            </div>
        )
    },
    {
        date: new Date(2018, Month.Dec, 11),
        name: "girls",
        poem: (
            <pre>
                c &nbsp;&nbsp; u &nbsp;&nbsp; t &nbsp;&nbsp; e &nbsp;&nbsp; g
                <br />
                <br />
                u &nbsp;&nbsp;i get anxious &nbsp; i
                <br />
                <br />
                t &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;around
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;r
                <br />
                <br />
                e
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                l
                <br />
                <br />g &nbsp;&nbsp;&nbsp;i &nbsp;&nbsp;&nbsp;r
                &nbsp;&nbsp;&nbsp;l &nbsp;&nbsp;&nbsp;s
            </pre>
        )
    },
    {
        date: new Date(2018, Month.Dec, 26),
        name: "hidden message",
        poem: (
            <div>
                from: me
                <br />
                <br />
                to: not you,
                <ReactComment text="I STILL LOVE YOU" />
            </div>
        )
    },
    {
        date: new Date(2018, Month.Dec, 29),
        name: "skills",
        poem: (
            <div>
                is being cool
                <br />
                <br />
                <br />
                <br />
                <OffsetText text="a learned skill" />
            </div>
        )
    },
    {
        date: new Date(2019, Month.Jan, 1),
        name: "i'M",
        poem: (
            <div>
                i'M
                <br />
                <br />
                the only one
                <br />
                <br />
                <br />
                who lives in thIs MEATsacK
            </div>
        )
    },
    {
        date: new Date(2019, Month.Jan, 3),
        name: "self reflection",
        poem: (
            <div>
                self reflection is nice when you don't fuck
                <br />
                <br />
                <RightAlignedText text="ing HATE yourself" />
            </div>
        )
    },
    {
        date: new Date(2019, Month.Feb, 13),
        name: "2019 thoughts",
        poem: (
            <div>
                <div style={{ textAlign: "center" }}>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    i
                    <br />
                    want
                </div>
            </div>
        )
    },
    {
        date: new Date(2019, Month.Mar, 30),
        name: "first phrase here,",
        poem: PoemUtils.twoPhrasePoem(
            "first phrase here,",
            "and then i gave her my mustard"
        )
    }
];

export interface Poem {
    date: Date;
    name: string;
    poem: React.ReactNode;
}
